import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { OilIntakeLogModel } from "../../models/oilProduction-model";

interface OilProductionSearchProps {
  setLoading: (loading: boolean) => void;
  onSearch: (data: OilIntakeLogModel[]) => void;
}


const OilProductionSearchRecords: React.FC<OilProductionSearchProps> = ({
  setLoading,
  onSearch,
}) => {
  const toast = useRef<Toast>(null);

  const [keyword, setKeyword] = useState("");
  // const [masterData, setMasterData] = useState<OilIntakeLogModel[]>([]);
  const [records, setRecords] = useState<OilIntakeLogModel[]>([]);

  const [oilseedOptions, setOilseedOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [selectedOilseed, setSelectedOilseed] = useState<number | null>(null);


//   useEffect(() => {
//   fetchAllLogs(); // fetch data from API on first load
// }, []);


// const fetchAllLogs = async () => {
//   setLoading(true);
//   try {
//     const response = await oilProductionService.getAllOilIntakeLogs();
    
//     // Sort by id descending
//     const sorted = response.sort((a: any, b: any) => b.id - a.id);
    
//     setRecords(sorted); // only API data populates the table
//   } catch (error) {
//     console.error("Failed to fetch logs", error);
//   } finally {
//     setLoading(false);
//   }
// };

  // Fetch all oil intake logs
const fetchAllData = async () => {
  setLoading(true);
  try {
    const response = await oilProductionService.getAllOilIntakeLogs();

    // Sort descending by ID so latest record comes first
    const sorted = [...response].sort((a, b) => Number(b.id) - Number(a.id));

    console.log("Sorted masterData IDs:", sorted.map(r => r.id)); // debug
    setRecords(sorted);
    onSearch(sorted); // initial display
  } catch (error) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "Failed to fetch oil production logs.",
    });
    onSearch([]);
  } finally {
    setLoading(false);
  }
};

  // Fetch oil intake logs on mount
  useEffect(() => {
    fetchAllData();
  }, []);

  // Fetch oilseed names for dropdown
  useEffect(() => {
    (async () => {
      try {
        const response = await oilProductionService.getAllOilSeedNames();
        const formatted = response.map((item: any) => ({
          label: item.name,
          value: item.id,
        }));
        setOilseedOptions(formatted);
      } catch (err) {
        console.error("Error fetching oilseeds:", err);
      }
    })();
  }, []);

  // Filter logic (manual)
const handleFilter = () => {
  debugger
  if (!records || records.length === 0) return;

  let filtered1 = [...records]; // start from records, not masterData

  // Keyword filter
  if (keyword.trim()) {
    const lowerKeyword = keyword.toLowerCase();
    filtered1 = filtered1.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(lowerKeyword)
      )
    );
  }

  // Oilseed filter
  if (selectedOilseed != null) {
    filtered1 = filtered1.filter(
      (item) => Number(item.oilSeedID) === Number(selectedOilseed)
    );
  }

  console.log("Filtered Data:", filtered1);
    onSearch(filtered1);
};



  // Reset filters
  const handleReset = () => {
    setKeyword("");
    setSelectedOilseed(null);
    onSearch(records);
  };

  return (
    <div className="card border-noround p-3 w-full">
      <Toast ref={toast} />

      <div className="grid align-items-center gap-3">
        {/* Keyword Search */}
        <div className="col-12 md:col-3">
          <div className="p-input-icon-left w-full">
            <i className="pi pi-search" />
            <InputText
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="Keyword Search"
              className="w-full"
            />
          </div>
        </div>

        {/* Oilseed Dropdown */}
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedOilseed}
            options={oilseedOptions}
            onChange={(e) => setSelectedOilseed(e.value)}
            placeholder="Select Oilseed"
            optionLabel="label"
            className="w-full"
            showClear
          />
        </div>

        {/* Filter Button */}
        <div className="col-12 md:col-2">
          <Button
            label="Filter"
            className="w-full"
            // severity="primary"
            onClick={handleFilter}
          />
        </div>

        {/* Reset Button */}
        <div className="col-12 md:col-2">
          <Button
            label="Reset"
            className="w-full"
            severity="success"
            onClick={handleReset}
          />
        </div>
      </div>
    </div>
  );
};

export default OilProductionSearchRecords;